export const redirectToParam = 'redirect_to';

/**
 * Accept only same-origin application paths as post-login destinations.
 * External URLs must never be accepted from a query parameter.
 */
export const getSafeRedirectPath = (
  candidate: string | null | undefined,
): string | undefined => {
  if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) {
    return undefined;
  }

  try {
    const baseUrl = 'https://breward.local';
    const url = new URL(candidate, baseUrl);

    if (url.origin !== baseUrl) {
      return undefined;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return undefined;
  }
};
